module.exports = __webpack_public_path__ + "img/thumb.f537dcf5.svg";